// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__wC7Dg"};